import React, {Fragment} from "react";
import ParticipantsModal from "../../modals/ParticipantsModal";
import avatarImg from "../../../../assets/img/demo/player-avatar-1.png";
import check from "../../../../assets/svg/actions/icn-check-green-20px.svg";
import plus from "../../../../assets/svg/actions/icn-plus-20px.svg";
import {Button} from "react-bootstrap";

class AddParticipantsModal extends ParticipantsModal {

    titles = {
        heading: "Add Participants",
        sub_heading: "Please search names you want to add in the group",
        submit: "Add Selected Participants"
    };

    state = {
        participants: Array.from(Array(25).keys())
            .map((item, index) => ({
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                info: 'Scout | Canberry Football Club',
                selected: false,
            }))
    };

    onSubmit = (event) => {
        event.preventDefault();
        var participants = this.state.participants.filter((item) => item.selected == true);
        if(this.props.onSubmit)
            this.props.onSubmit(event, participants);

        this.setState({
            participants: this.state.participants.map((item) => {
                item.selected = false
                return item
            })
        })
    }

    activeIcon  = () => {
        return check;
    }

    inactiveIcon = () => {
        return plus;
    }

    renderFooter = () => {
        var count_participants = this.state.participants.filter((item) => item.selected == true).length;
        return (
            <Button variant="primary" className="btn-block btn-lg" onClick={this.onSubmit} disabled={!count_participants}>{this.titles.submit}</Button>
        );
    }
};

export default AddParticipantsModal;